import { inject, Injectable } from '@angular/core';
import { ViewConfig } from '../../../models/view-config.interface';
import { DeliveryNotesPaginatedService } from '@app/consignor/services/delivery-notes-paginated.service';
import { ConsignorFoldersPaginatedService } from '@app/consignor/services/consignor-folders-paginated.service';
import { DeliveryNoteBundlesService } from 'api/services';
import { ConsignorViewActionsService } from '../consignor-view-actions.service';
import { AppStore } from '@app/stores/appStore';
import { SearchStore } from '@app/stores/searchStore';
import { SelectionStore } from '@app/stores/selectionStore';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

// Import individual config factories
import { ConsignorFoldersConfig } from './folders-config';
import { ConsignorDeliveryNotesConfig } from './deliverynotes-config';
import { ConsignorEcmrConfig } from './ecmr-config';

/**
 * Consignor View Configuration Index
 * Aggregates all consignor-specific view configurations
 */
@Injectable({
    providedIn: 'root',
})
export class ConsignorViewConfigService {
    private appStore = inject(AppStore);
    private searchStore = inject(SearchStore);
    private selectionStore = inject(SelectionStore);

    constructor(
        private deliveryNotesPaginatedService: DeliveryNotesPaginatedService,
        private consignorFoldersPaginatedService: ConsignorFoldersPaginatedService,
        private deliveryNoteBundlesService: DeliveryNoteBundlesService,
        private actionsService: ConsignorViewActionsService,
        private router: Router,
        private dialog: MatDialog
    ) {}

    getViewConfigs(): Map<string, ViewConfig> {
        const configs = new Map<string, ViewConfig>();

        // Folders configuration
        configs.set(
            'consignor-folders',
            ConsignorFoldersConfig.create({
                consignorFoldersPaginatedService:
                    this.consignorFoldersPaginatedService,
                deliveryNoteBundlesService: this.deliveryNoteBundlesService,
                actionsService: this.actionsService,
                appStore: this.appStore,
                selectionStore: this.selectionStore,
            })
        );

        // Delivery Notes configuration
        configs.set(
            'consignor-deliverynotes',
            ConsignorDeliveryNotesConfig.create({
                deliveryNotesPaginatedService:
                    this.deliveryNotesPaginatedService,
                actionsService: this.actionsService,
                appStore: this.appStore,
                selectionStore: this.selectionStore,
            })
        );

        // ecmr - custom view
        configs.set(
            'consignor-ecmr',
            ConsignorEcmrConfig.create({
                router: this.router,
                dialog: this.dialog,
                appStore: this.appStore,
                searchStore: this.searchStore,
            })
        );

        return configs;
    }
}
